import { call, put, select, cancelled } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import { get } from 'lodash';

import { withApiErrorHandling } from 'utils/redux/sagaHelper';
import { statsService } from 'utils/api';

import session from 'containers/App/session';

import { createActions, createReducer, createSagaWatcher, createSelectors } from '../generators';

const KEY = 'roomTypes';
const PARAMETERS = ['propertyId'];
const actions = createActions(KEY, PARAMETERS);
const { fetchCancelled, fetchStarted, fetchSucceeded, fetchFailed } = actions;

const parseData = (data) => {
    const categories = data.reduce((accu, row) => {
        if (row.category == null || accu[row.category.uuid]) return accu;
        return {
            ...accu,
            [row.category.uuid]: row.category,
        };
    }, {});
    return {
        categories,
        roomTypes: data.reduce(
            (accu, row) => ({
                ...accu,
                [row.uuid]: row,
            }),
            {},
        ),
        defaultRoomType: data.find((row) => row.isDefault === true),
    };
};

function* fetchSaga(action) {
    try {
        const { params } = action;
        const { propertyId } = params;
        yield put(fetchStarted(params));

        const token = yield select(session.selectors.selectUserToken);
        const { response, error } = yield call(withApiErrorHandling, statsService({ token, propertyId }).getRoomTypes);
        if (response) {
            yield put(fetchSucceeded(parseData(response.data)));
        } else {
            yield put(fetchFailed(error));
        }
    } catch (error) {
        yield put(fetchFailed(error));
    } finally {
        if (yield cancelled()) yield put(fetchCancelled());
    }
}

const selectors = createSelectors(KEY);

selectors.selectRoomTypes = createSelector(selectors.selectData, (state) => get(state, 'roomTypes', {}));
selectors.selectCategories = createSelector(selectors.selectData, (state) => get(state, 'categories', {}));
selectors.selectDefaultRoomType = createSelector(selectors.selectData, (state) => get(state, 'defaultRoomType', {}));

export default {
    KEY,
    actions,
    reducer: createReducer(KEY),
    saga: createSagaWatcher(KEY, fetchSaga),
    selectors,
};

export { fetchSaga };
